import { render, staticRenderFns } from "./OnBoardingApp.vue?vue&type=template&id=28161f96&scoped=true&"
import script from "./OnBoardingApp.vue?vue&type=script&lang=js&"
export * from "./OnBoardingApp.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingApp.vue?vue&type=style&index=0&id=28161f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28161f96",
  null
  
)

export default component.exports